import { render } from "./Header.vue?vue&type=template&id=52a458af&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=52a458af&scoped=true&lang=scss"

import exportComponent from "E:\\watersoftdesarrollo\\GitHub\\Sisflex_toma_pedidos_web\\Sistema\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a458af"]])

export default __exports__